import { GridColDef } from '@mui/x-data-grid';

import { GetRateCodes } from '~/services/cruises/RateCodeService';

export type BooleanFilter = '' | 'true' | 'false';

export interface RateCodeSearchState {
  rateCode: string;
  isFlash: BooleanFilter;
  isNetRate: BooleanFilter;
}

export const RATE_CODE_INITIAL_SEARCH: RateCodeSearchState = {
  rateCode: '',
  isFlash: '',
  isNetRate: '',
};

export function parseBooleanFilter(value: BooleanFilter): boolean | undefined {
  if (value === 'true') {
    return true;
  }
  if (value === 'false') {
    return false;
  }
  return undefined;
}

export const rateCodeColumns: Array<GridColDef<GetRateCodes>> = [
  {
    field: 'code',
    headerName: 'Rate Code',
    flex: 2,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: 'vendor',
    headerName: 'Cruise Line',
    flex: 2,
    sortable: false,
    disableColumnMenu: true,
    valueGetter: (_, row) => row.vendor?.name ?? '—',
  },
  {
    field: 'isFlash',
    headerName: 'Flash',
    flex: 1,
    sortable: false,
    disableColumnMenu: true,
    valueGetter: (_, row) => (row.isFlash ? 'Yes' : 'No'),
  },
  {
    field: 'isNetRate',
    headerName: 'Net Rate',
    flex: 1,
    sortable: false,
    disableColumnMenu: true,
    valueGetter: (_, row) => (row.isNetRate ? 'Yes' : 'No'),
  },
  {
    field: 'isEnabled',
    headerName: 'Enabled',
    flex: 1,
    sortable: false,
    disableColumnMenu: true,
    valueGetter: (_, row) => (row.isEnabled ? 'Yes' : 'No'),
  },
];
